module.exports = __webpack_public_path__ + "img/icon_map_lsjjr.6b0368b9.png";